export const BEFORE_FETCH_CAMPAIGNS = 'BEFORE_FETCH_CAMPAIGNS';
export const FETCH_CAMPAIGNS = 'FETCH_CAMPAIGNS';
export const ERROR_FETCHING_CAMPAIGNS = 'ERROR_FETCHING_CAMPAIGNS';

export const BEFORE_PROMOTE_ACTION = 'BEFORE_PROMOTE_ACTION';
export const RESPONSE_PROMOTE_ACTION = 'RESPONSE_PROMOTE_ACTION';
export const ERROR_PROMOTE_ACTION = 'ERROR_PROMOTE_ACTION';